import { render, staticRenderFns } from "./ProfileInfos.vue?vue&type=template&id=aaa4f570&scoped=true"
import script from "./ProfileInfos.vue?vue&type=script&lang=js"
export * from "./ProfileInfos.vue?vue&type=script&lang=js"
import style0 from "./ProfileInfos.vue?vue&type=style&index=0&id=aaa4f570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa4f570",
  null
  
)

export default component.exports